import { Loader, type TLoaderProps } from '@crehana/compass.ui/loader';
import { cn } from '@crehana/compass.ui/v2';
import { useTranslation } from '@crehana/i18n';
import type { LANGUAGES } from '@crehana/ts-types';

type TSectionLoaderProps = {
  className?: string;
  withLabel?: boolean;
  size?: TLoaderProps['size'];
};

export const SectionLoader = ({
  className,
  withLabel,
  size,
}: TSectionLoaderProps) => {
  const { languageCode } = useTranslation();

  const label: Record<LANGUAGES, string> = {
    es: 'Cargando...',
    en: 'Loading...',
    pt: 'Carregando...',
  };

  return (
    <div
      className={cn(
        'cds:flex cds:flex-col tw-gap-2 cds:items-center cds:justify-center cds:h-full cds:w-full',
        className,
      )}
    >
      <Loader size={size} />
      {withLabel && (
        <p className="cds:text-subtle cds:text-1.6 cds:font-sans cds:tracking-0 cds:font-medium cds:leading-2.2">
          {label[languageCode]}
        </p>
      )}
    </div>
  );
};
